import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import StepNavigationComponent from '../../../components/shared_components/tool/StepNavigationComponent';
import InputComponent from '../../../components/shared_components/InputComponent';
import PrimaryButton from '../../../components/shared_components/buttons/PrimaryButtonComponent';
import ToggleComponent from '../../../components/shared_components/ToggleComponent';
import DropDown from '../../../semantic_select_modules/semantic/components/dropdown';
import Transition from '../../../semantic_select_modules/semantic/components/transition';
import SelectCustom from '../../../semantic_select_modules/terugkerendeElementen/form/select';
import SemanticSelectCustom from '../../../semantic_select_modules/terugkerendeElementen/form/semanticSelect';
import InformationBoxComponent from '../../../components/shared_components/InformationBoxComponent';
import ErrorAlertComponent from '../../../components/shared_components/ErrorAlertComponent';
import ValidationData from '../../../stores/tool/validation/ValidationStore';
import { setItemLocalStorage } from '../../../stores/tool/storage/storage';

@withRouter
@observer
class CalculationFormContainer extends React.Component {
  constructor(props) {
    super(props);
    this.showTextBox = this.showTextBox.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  componentDidMount() {
    DropDown($, window, document, undefined);
    Transition($, window, document, undefined);
    SelectCustom.init();
    SemanticSelectCustom.init();
    this.props.CalculationFormData.getChfLtv();
  }

  validateForm() {
    const {
      // eslint-disable-next-line prefer-const
      getInterestAndSortTable,
    } = this.props.CalculationFormData;

    const {
      sortLabelInterestsByTermInterest,
      sortLabelInterestsByTermInterestAvailable,
    } = this.props.ToolOverviewData;

    // Clear labelInterest before calling getInterestAndSortTable
    this.props.CalculationFormData.labelInterests = [];
    if (this.props.CalculationFormData.validateForm()) {
      this.props.history.push('step-2');
      getInterestAndSortTable(() => {
        this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterestAvailable(
          this.props.CalculationFormData.labelInterests);
        this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterest(20,
          this.props.CalculationFormData.labelInterests);
        setItemLocalStorage(this.props.CalculationFormData.labelInterests, 'LooptijdRenteLabelInterests');
      });
    }
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const { setForm, form, toggleNHG, chfLtv } = this.props.CalculationFormData;
    const { informationBoxData } = this.props.InformationBoxData;

    const enableNHGToggle = true;

    return (
      <div className="calculation-container-tool">
        <div>
          <StepNavigationComponent
            classNames="medium-42 columns float-right"
          />
        </div>
        <ErrorAlertComponent
          show={ValidationData.responseError}
          responseError={ValidationData.responseError}
          errorFields={ValidationData.errorFields}
        />
        <div className="columns medium-84 tool-header">
          <h1>Wat worden mijn maandlasten</h1>
          <p>
            Vul hieronder uw vraagprijs of verwachte hypotheekbedrag in en daarnaast het bedrag aan eigen geld in wat u
            meeneemt ter besteding van uw hypotheek
          </p>
        </div>
        <div className="tool-input-fields">
          <div className="large-21 medium-84 columns">
            <InputComponent
              label="Vraagprijs"
              placeholder="Gewenste hypotheek"
              onChange={setForm}
              value={form.mortgage}
              name="mortgage"
              currency
            >
              <InformationBoxComponent
                classNames="info-box-toggle"
                onClickHandler={(event) => {
                  this.showTextBox(informationBoxData.mortgage, event);
                }}
              />
            </InputComponent>
          </div>
          <div className="large-21 medium-84 columns">
            <InputComponent
              label="Eigen geld"
              placeholder="Eigen inleg"
              onChange={setForm}
              value={form.personalDeposit}
              name="personalDeposit"
              currency
            >
              <InformationBoxComponent
                classNames="info-box-toggle"
                onClickHandler={(event) => {
                  this.showTextBox(informationBoxData.mortgage, event);
                }}
              />
            </InputComponent>
          </div>
          <div className="large-14 medium-84 columns">
            <ToggleComponent
              classNames="toggle-nhg"
              label={'NHG'}
              checked={form.nhg === 1}
              id={'toggle-nhg'}
              handleInputChange={toggleNHG}
              show={enableNHGToggle}
            >
              <InformationBoxComponent
                classNames="info-box-toggle"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.nhg, event); }}
              />
            </ToggleComponent>
          </div>
          <div className="large-14 medium-84 columns end calculation-container-tool__submit">
            <PrimaryButton
              text="Verder"
              classNames={'primary-submit-button-tool'}
              onClickHandler={this.validateForm}
              show
              disabled={!chfLtv}
            />
          </div>
        </div>
      </div>
    );
  }
}

CalculationFormContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  ToolOverviewData: PropTypes.shape({
    sortLabelInterestsByTermInterest: PropTypes.func,
    sortLabelInterestsByTermInterestAvailable: PropTypes.func,
  }),
  CalculationFormData: PropTypes.shape({
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
    chfLtv: PropTypes.shape.string,
    validateForm: PropTypes.func,
    getChfLtv: PropTypes.func,
    setForm: PropTypes.func,
    toggleNHG: PropTypes.func,
    getInterestAndSortTable: PropTypes.func,
    form: PropTypes.shape({}),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({}),
    openModal: PropTypes.func,
  }),
};

CalculationFormContainer.defaultProps = {
  history: {
    push: () => {},
  },
  ToolOverviewData: {
    sortLabelInterestsByTermInterest: () => {},
    sortLabelInterestsByTermInterestAvailable: () => {},
  },
  CalculationFormData: {
    labelInterests: [],
    chfLtv: '',
    validateForm: () => {},
    getChfLtv: () => {},
    setForm: () => {},
    toggleNHG: () => {},
    getInterestAndSortTable: () => {},
    form: {},
  },
  InformationBoxData: {
    informationBoxData: {},
  },
  ModalData: {
    openModal: () => {},
  },
};

export default inject('CalculationFormData',
  'ValidationData',
  'ToolOverviewData',
  'InformationBoxData',
  'ModalData')(CalculationFormContainer);
